import { Dispatch, SetStateAction, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Button } from 'components/button';
import { Icon } from 'components/icon/icon';

import IconFilter from 'public/assets/icons/filter.svg';
import IconSelect from 'public/assets/icons/union.svg';

import styles from '../search-overview.module.scss';

export interface IMobileActionsProps {
	filtersIsOpen: boolean;
	setFiltersIsOpen: Dispatch<SetStateAction<boolean>>;
	sortIsOpen: boolean;
	setSortIsOpen: Dispatch<SetStateAction<boolean>>;
	filterHeader?: string;
	filterIcon?: React.JSX.Element;
}

export const MobileActions = ({
	filtersIsOpen,
	setFiltersIsOpen,
	sortIsOpen,
	setSortIsOpen,
	filterHeader,
	filterIcon
}: IMobileActionsProps): React.JSX.Element => {
	const intl = useIntl();

	useEffect(() => {
		if (filtersIsOpen || sortIsOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'visible';
		}
	}, [filtersIsOpen, sortIsOpen]);

	return (
		<div className={styles.mobileButtons}>
			<Button
				variant="secondary-light"
				title={filterHeader ?? intl.formatMessage({ id: 'global.filter' })}
				icon={filterIcon ?? <Icon customIcon={<IconFilter />} size="14px" />}
				onClick={() => setFiltersIsOpen(!filtersIsOpen)}
				fullWidth
			/>
			<Button
				variant="secondary-light"
				title={intl.formatMessage({ id: 'global.sort' })}
				icon={<Icon customIcon={<IconSelect />} size="14px" />}
				onClick={() => setSortIsOpen(!sortIsOpen)}
				fullWidth
			/>
		</div>
	);
};

export default MobileActions;
